import React from 'react';
import PropTypes from 'prop-types';


import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";

const BatchRecordTable = ({ list, recordAction, onErrorClick, onClaimIDClick, onClaimNumberClick }) => {
  if (!list){
    return (
      <div/>
    );
  }

  let title = "skráningar";
  if (recordAction === 2){
    title = "afskráningar";
  }

  return (
    <div className="calc-setting-table ">
      <table className="table">
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="13" className="text-left calc-setting-table-header">Færslur til {title}</th>
        </tr>
        <tr>

          <th className="text-left">TrackID</th>
          <th className="text-left">ClaimID</th>
          <th className="text-left">ClaimState</th>

          <th className="text-left">ClaimDate</th>
          <th className="text-left">ClaimType</th>

          <th className="text-left">Debtor Regno</th>
          <th className="text-left">Owner Regno</th>
          <th className="text-left">PO Regno</th>

          <th className="text-left">Repr. Regno</th>
          <th className="text-left">ClaimNumber</th>

          <th className="text-left">Deact.Reason</th>

          <th className="text-left">UpdatedDate</th>
          <th className="text-left">UpdatedBy</th>
        </tr>
        </thead>
        <tbody>
        {list.map(function(item,i){
          return(
            <tr key={i}>
              <td className="text-left">{item.trackID.toString()}</td>

              {item.claimID && <td className="text-left"><a onClick={(e)=>onClaimIDClick(e,item)}>{item.claimID.toString()}</a> </td>}
              {!item.claimID && <td className="text-left"> </td>}


              { item.claimState === 4 && <td className="text-left"><a onClick={(e)=>onErrorClick(e,item)}><ClaimState data={item.claimState}/></a> </td>}
              { item.claimState !== 4 && <td className="text-left"><ClaimState data={item.claimState}/></td>}



              <td className="text-left"><DateTime data={item.claimDate}/></td>
              <td className="text-left">{item.claimType}</td>

              <td className="text-left">{item.debtorRegno}</td>
              <td className="text-left">{item.claimOwnerRegno}</td>
              <td className="text-left">{item.publicOfficeRegno}</td>
              <td className="text-left">{item.representativeRegno}</td>

              <td className="text-left"><a onClick={(e)=>onClaimNumberClick(e,item)}>{item.claimNumber}</a> </td>

              <td className="text-left">{item.meaning}</td>

              <td className="text-left"><DateTime data={item.updatedDate}/></td>
              <td className="text-left">{item.updatedByUsername} </td>
            </tr>);
        })}
        </tbody>
      </table>
    </div>
  );
};

BatchRecordTable.propTypes = {
  list: PropTypes.array,
  recordAction: PropTypes.number,
  onErrorClick : PropTypes.func,
  onClaimIDClick : PropTypes.func,
  onClaimNumberClick : PropTypes.func
};

export default BatchRecordTable;




// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Batch/BatchRecordTable.js